import { render, staticRenderFns } from "./Understand.vue?vue&type=template&id=1727cd03&scoped=true&"
import script from "./Understand.vue?vue&type=script&lang=js&"
export * from "./Understand.vue?vue&type=script&lang=js&"
import style0 from "./Understand.vue?vue&type=style&index=0&id=1727cd03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1727cd03",
  null
  
)

/* custom blocks */
import block0 from "./Understand.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports